// extracted by mini-css-extract-plugin
export default {"controlButton":"UuvzuH","hidden":"SWiF19","overlay":"P9q5GM","active":"L8SYSN","poster":"jyZxBT","icon":"oVB0VT","transparency":"DUKkm6"};